export default __webpack_public_path__ + "static/media/PrivacyPolicy.dc4ec30f.pdf";